"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HeaderSecondaryNavigation_1 = __importDefault(require("./HeaderSecondaryNavigation"));
exports.default = HeaderSecondaryNavigation_1.default;
